let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("55Men")).then(() => parcelRequire('l96Bx'));